// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"f8e71770","453":"afd13ae1","545":"5292853f","553":"cf2eb1c3"}[chunkId] + ".chunk.js";
};